<div class="dn-dialog-icon">
    <img [src]="icon"
         *ngIf="icon"
         style="height: 40px; width: 40px;" />
</div>
<div class="message" [ngClass]="{noIcon: !icon}">
    <div [innerHTML]="message" style="padding: 0 20px;"></div>
</div>
